import { render, staticRenderFns } from "./DestinationDocument.vue?vue&type=template&id=2764cab3&scoped=true&"
import script from "./DestinationDocument.vue?vue&type=script&lang=js&"
export * from "./DestinationDocument.vue?vue&type=script&lang=js&"
import style0 from "./DestinationDocument.vue?vue&type=style&index=0&id=2764cab3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764cab3",
  null
  
)

export default component.exports